import { useTheme } from "@emotion/react";
import React from "react";

import { Button, Modal } from "~/components/blocks";

import { PrivacyPolicy } from "./PrivacyPolicy";

type Props = {
  open: boolean;
  onClose: () => void;
};

export const PrivacyPolicyModal = React.memo((props: Props) => {
  const theme = useTheme();

  return (
    <Modal open={props.open}>
      <PrivacyPolicy />
      <Button
        use="base"
        wide="fill"
        marginTop={theme.space.xl}
        onClick={props.onClose}
      >
        閉じる
      </Button>
    </Modal>
  );
});

PrivacyPolicyModal.displayName = "PrivacyPolicyModal";
